/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */
import { getTriAppConfig } from "../../TriAppConfig";

const IMAGE_URL = "/getCompanyFile.jsp";
const THUMBNAIL_URL = "/html/en/default/images/getImageThumbnail.jsp";
const IMAGE_PARAM_NAME = "fileLoc";

export function getImageUrl(imageValue, thumbnail) {
  if (isImageValueNotEmpty(imageValue)) {
    if (typeof imageValue === "object" && imageValue.isUnsavedImage) {
      return imageValue.image;
    } else {
      let imageUrl = null;
      const { tririgaUrl } = getTriAppConfig();
      if (thumbnail) {
        imageUrl = new URL(`${tririgaUrl}${THUMBNAIL_URL}`);
      } else {
        imageUrl = new URL(`${tririgaUrl}${IMAGE_URL}`);
      }
      imageUrl.searchParams.set(IMAGE_PARAM_NAME, imageValue);
      return imageUrl;
    }
  } else {
    return null;
  }
}

function isImageValueNotEmpty(imageValue) {
  return (
    imageValue != null &&
    ((typeof imageValue === "object" && imageValue.isUnsavedImage) ||
      imageValue.length > 0)
  );
}
